<div class="modal-header">
    <h4 class="modal-title">{{ dialogHeader }}</h4>
</div>
<div class="modal-body">
    <div class="d-flex mb-1">
        <dx-text-box [(value)]="newValue" width="100%"></dx-text-box>
        <button type="button" (click)="addValue()" class="btn btn-success ms-2">Add</button>
    </div>
    <dx-list [items]="values" [height]="200" [allowItemDeleting]="true" [itemDeleteMode]="'static'" [showSelectionControls]="false">
        <div *dxTemplate="let item of 'item'">
            <div>{{ item }}</div>
        </div>
        <!-- <dxo-item-dragging [data]="values" [allowReordering]="true"> </dxo-item-dragging> -->
    </dx-list>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="save()">{{ dialogSaveText }}</button>
    <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
